import React, { type FC } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { useApprovals } from '../ApprovalsContext.tsx';

const i18n = defineMessages({
	approvalInProgressBannerMessage: {
		id: 'approvals.editor.approval-in-progress.banner.non-final',
		description:
			'Banner message when user is on edit page but approval is in progress - editing is disabled.',
		defaultMessage:
			"Editing isn't available during an approval. Clear the approval to make changes.",
	},
});

const styles = cssMap({
	banner: {
		height: '40px',
		paddingBlock: token('space.050'),
		paddingInline: token('space.250'),
		backgroundColor: token('elevation.surface.sunken'),
	},
});

/**
 * When approval is in progress (isDraftLockedForEditing), shows a banner explaining that editing
 * is not allowed. Renders nothing when there is no approval in progress.
 */
export const ApprovalInProgressEditorBlocker: FC = () => {
	const { formatMessage } = useIntl();
	const { isDraftLockedForEditing } = useApprovals();

	if (!isDraftLockedForEditing) {
		return null;
	}

	return (
		<Flex xcss={styles.banner} alignItems="center" justifyContent="center">
			<Text>{formatMessage(i18n.approvalInProgressBannerMessage)}</Text>
		</Flex>
	);
};
